import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { AgencyGoogleAdsPage } from '@/features/agency';
import { formatDocumentTitle } from '@/lib/document-title';

/** Every agency member may use it (the parent layout gates non-agency users; the API scopes salons). */
export const Route = createFileRoute('/_auth/agency/google-ads')({
  component: AgencyGoogleAdsRoute,
});

function AgencyGoogleAdsRoute() {
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Google Ads')}</title>
      </Helmet>
      <AgencyGoogleAdsPage />
    </>
  );
}
